/**
 * Generates a unique ID using Crypto (supported by modern browsers: Chrome 92+, Firefox 95+, Safari 15+, Edge 92+)
 * Uses crypto.randomUUID() when available; falls back to crypto.getRandomValues().
 * @returns {string}
 */
export default function genUID() {
    if (crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Fallback
    const arr = new Uint32Array(2);
    crypto.getRandomValues(arr);
    return [...arr].map(n => n.toString(36)).join('');
}